export default __webpack_public_path__ + "static/media/logo-bpp-mini.fb3a1118.svg";